import React from 'react'
import { CloseIcon } from '../_components'
import { toast } from 'react-toastify'

export const handleTestNotification = (title, body, image, icon, url) => {
    if ( !title ) return toast.warn(<><CloseIcon /> É necessário informar o <strong>Título da Notificação</strong> antes de testá-la.</>, {
        position: toast.POSITION.TOP_RIGHT,
        className: 'toast--white toast--error'
      });
    
    const options = {
      body,
      image,
      icon,
      url
    }

    Notification.requestPermission(function (permission) {
      if (Notification.permission === "granted") {
        const notification = new Notification(title, options);

        notification.onclick = function(event) {
          event.preventDefault();
          window.open(options.url, '_blank');
        }
      } else {
        Notification.requestPermission(function (permission) {
            if (permission === "granted") {
              new Notification(title, options);
            }
          });
      }
    });
  }